import Button from "@/common/components/Button";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { FormTransformers } from "@/common/utils/formTransformers";
import { MaintenanceForwardingSectionsProps } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/features/forwardings/types/maintenanceForwarding.type";
import { useMaintenanceDirectiveDiagnosticEntryRegress } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/hooks/forwardings/directive/diagnosticEntries/useMaintenanceDirectiveDiagnosticEntryRegress";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

const DirectiveEntryDiagnosticEntriesRegress = ({
  forwarding,
}: MaintenanceForwardingSectionsProps) => {
  const queryClient = useQueryClient();

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: regress,
    isPending: regressIsPending,
  } = useMaintenanceDirectiveDiagnosticEntryRegress({
    directiveEntryId: forwarding.directive_entry?.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['maintenanceForwarding', forwarding.id],
        });
      },
      onError: (error) => {
        FormTransformers.errorsTransformer({
          setMessages,
        })(error);
      }
    }
  });

  return (
    <>
      <Button
        variant="yellow-black"
        operationKlassToCheckPermission="Admin::Maintenance::Directive::DiagnosticEntries::Regress"
        onClick={() => regress()}
        isLoading={regressIsPending}
      >
        Solicitar revisão
      </Button>

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default DirectiveEntryDiagnosticEntriesRegress;
